module.exports = __webpack_public_path__ + "overview-a5b6df21/super-ellipse-mask-cd22c3b8c137c9902b90787d046b531a.svg";